import React from 'react';

import { EmailChange } from './components/EmailChange';

import { ManagedPopup } from 'js/components/common/Popup';
import { useOnClose } from 'js/components/common/PopupManager';

import { useTranslations } from 'js/hooks/i18n';

import style from './EmailChangePopup.scss';

export const EmailChangePopup = ({ id }) => {
    const closePopup = useOnClose(id);
    const translate = useTranslations('playtech.mobile.system.changeemail.');

    return (
        <ManagedPopup
            isModal
            isNotCloseAfterRedirect
            className={style.popup}
            classNames={{ header: style.header, inner: style.inner }}
            title={translate('popup.title')}
        >
            <EmailChange closePopup={closePopup} />
        </ManagedPopup>
    );
};
